import gladTransitionIcon from "@assets/glad_transition.png"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { Trans, useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

export default function TransitionPage() {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center gap-5 text-center">
        <img
          src={gladTransitionIcon}
          alt="Transition icon"
          className="h-auto w-40 rounded-lg"
        />

        <h1 className="custom-heading">
          {t("pages.onboardingV1.transition.heading")}
        </h1>

        <p className="text-xl">
          <Trans
            components={{
              colored: <span className="custom-text-colored font-bold" />,
            }}
            i18nKey="pages.onboardingV1.transition.text"
          />
        </p>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t("pages.onboardingV1.transition.heading", { lng: "en" })}
          type="hidden"
          value={t("shared.continue", { lng: "en" })}
        />

        <Button title={t("shared.continue")} type="submit" />
      </Form>
    </Layout>
  )
}
